import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '@/hooks/useCart';
import { cn } from '@/lib/utils';
import { useReturnFocus } from '@/hooks/useReturnFocus';
import { useUiStore } from '@/stores/ui.store';
import { CartContents } from './cart-contents';

/**
 * SEPET PANELİ
 *
 * Masaüstünde sağdan açılan drawer. Mobilde kullanıcı doğrudan /sepet
 * sayfasına yönlendirilir: dar ekranda tam sayfa deneyim, üst üste binen
 * katmanlardan daha rahattır.
 */
export function CartDrawer() {
  const overlay = useUiStore((state) => state.overlay);
  const closeOverlay = useUiStore((state) => state.closeOverlay);
  const navigate = useNavigate();
  const { data: cart } = useCart();

  const open = overlay === 'cart';

  // Kapanışta odak, çekmeceyi açan düğmeye geri döner.
  useReturnFocus(open);

  // Mobilde panel yerine sayfa açılır.
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;

  if (open && isMobile) {
    closeOverlay();
    void navigate('/sepet');
    return null;
  }

  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && closeOverlay()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-ink/25 backdrop-blur-[2px] data-[state=open]:animate-in data-[state=open]:fade-in" />

        <Dialog.Content
          className={cn(
            'fixed right-0 top-0 z-50 flex h-dvh w-full max-w-md flex-col',
            'border-l border-line bg-surface shadow-lift',
            'data-[state=open]:animate-in data-[state=open]:slide-in-from-right',
          )}
        >
          <div className="flex items-center justify-between border-b border-line px-5 py-4">
            <Dialog.Title className="font-serif text-lg text-ink">
              Sepetiniz
              {cart && cart.itemCount > 0 ? (
                <span className="ml-2 text-sm text-ink-muted">
                  ({cart.itemCount})
                </span>
              ) : null}
            </Dialog.Title>

            <Dialog.Close
              aria-label="Sepeti kapat"
              className="-mr-1 flex size-9 items-center justify-center rounded-sm text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
            >
              <X className="size-[18px]" aria-hidden />
            </Dialog.Close>
          </div>

          <Dialog.Description className="sr-only-focusable">
            Sepetinizdeki ürünler ve tutarlar.
          </Dialog.Description>

          <div className="min-h-0 flex-1">
            <CartContents onNavigate={closeOverlay} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
